import { FormField } from "../../shared/components/dynamic-form/dynamic-form.interface";



export const CLIENT_ADVISOR_FORM: FormField[] = [
  {
    key: 'session_conducted',
    label: '¿Se llevó a cabo la sesión programada?',
    type: 'radio',
    required: true,
    options: [
      {
        value: 'yes',
        label: 'Sí',
      },
      {
        value: 'no',
        label: 'No',
      },
    ],
    colSpan: 2,
  },
  {
    key: 'reason',
    label: '¿Cuál fue la razón?',
    type: 'textarea',
    required: true,
    minLength: 3,
    maxLength: 1000,
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'no'
    },
  },
  {
    key: 'utility_rating',
    label: 'Del 1 al 5 ¿Como calificarías la utilidad del asesoramiento recibido? ',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Muy insatisfecho/a' },
      { value: 2, label: '2 - Ligeramente insatisfecho/a' },
      { value: 3, label: '3 - Neutral' },
      { value: 4, label: '4 - Satisfecho/a' },
      { value: 5, label: '5 - Muy satisfecho/a' },
    ],
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'yes'
    },
  },
  {
    key: 'communication_rating',
    label: 'Del 1 al 5 ¿Cuán clara y cálida fue la comunicación con la persona que te asesoró?',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Muy insatisfecho/a' },
      { value: 2, label: '2 - Ligeramente insatisfecho/a' },
      { value: 3, label: '3 - Neutral' },
      { value: 4, label: '4 - Satisfecho/a' },
      { value: 5, label: '5 - Muy satisfecho/a' },
    ],
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'yes'
    },
  },
  {
    key: 'recommendation_rating',
    label: '¿Recomendarías este asesoramiento a otras personas interesadas?',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Totalmente en desacuerdo' },
      { value: 2, label: '2 - En desacuerdo con ciertos aspectos' },
      { value: 3, label: '3 - Indeciso/a' },
      { value: 4, label: '4 - De acuerdo con ciertos aspectos' },
      { value: 5, label: '5 - Totalmente de acuerdo' },
    ],
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'yes'
    },
  },
  {
    key: 'valuable_aspects',
    label: 'Cuéntanos qué fue lo más valioso del asesoramiento ¡Cada detalle nos importa!',
    type: 'textarea',
    required: true,
    minLength: 10,
    maxLength: 20000,
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'yes'
    },
  },
  {
    key: 'improvement_aspects',
    label: 'Cuéntanos qué crees que este asesor/a podría mejorar. ¡Cada consejo cuenta!',
    type: 'textarea',
    required: true,
    minLength: 10,
    maxLength: 20000,
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'yes'
    },
  },
];


export const ADVISOR_CLIENT_FORM: FormField[] = [
  {
    key: 'session_conducted',
    label: '¿Se llevó a cabo la sesión programada?',
    type: 'radio',
    required: true,
    options: [
      {
        value: 'yes',
        label: 'Sí',
      },
      {
        value: 'no',
        label: 'No',
      },
    ],
    colSpan: 2,
  },
  {
    key: 'reason',
    label: '¿Cuál fue la razón?',
    type: 'textarea',
    required: true,
    minLength: 3,
    maxLength: 1000,
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'no'
    },
  },
  {
    key: 'commitment_rating',
    label: 'Del 1 al 5 ¿Cómo calificarías la apertura y compromiso de este cliente con el proceso de trabajo en esta sesión?',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Muy insatisfecho/a' },
      { value: 2, label: '2 - Ligeramente insatisfecho/a' },
      { value: 3, label: '3 - Neutral' },
      { value: 4, label: '4 - Satisfecho/a' },
      { value: 5, label: '5 - Muy satisfecho/a' },
    ],
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'yes'
    },
  },
  {
    key: 'communication_rating',
    label: 'Del 1 al 5 ¿Cuán clara y cálida fue la comunicación con la persona que asesoraste?',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Muy insatisfecho/a' },
      { value: 2, label: '2 - Ligeramente insatisfecho/a' },
      { value: 3, label: '3 - Neutral' },
      { value: 4, label: '4 - Satisfecho/a' },
      { value: 5, label: '5 - Muy satisfecho/a' },
    ],
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'yes'
    },
  },
  {
    key: 'rework_rating',
    label: '¿Volverías a trabajar con este cliente?',
    type: 'radio',
    required: true,
    options: [
      {
        value: 'yes',
        label: 'Sí',
      },
      {
        value: 'no',
        label: 'No',
      },
    ],
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'yes'
    },
  },
  {
    key: 'observations',
    label: 'Observaciones relevantes sobre el cliente',
    type: 'textarea',
    required: true,
    minLength: 10,
    maxLength: 20000,
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'yes'
    },
  },
  {
    key: 'area',
    label: '¿Cuál es el área en el que trabajaron?',
    type: 'multiselect',
    required: true,
    options: [
      { value: 'comercial', label: 'Comercial' },
      { value: 'administracion', label: 'Administración' },
      { value: 'tributacion', label: 'Tributación' },
      { value: 'inventarios_adquisiciones', label: 'Inventarios y adquisiciones' },
      { value: 'registros_contables', label: 'Registros contables' },
      { value: 'tesoreria', label: 'Tesorería' },
      { value: 'obligaciones_sociales_patronales', label: 'Obligaciones sociales y patronales' },
      { value: 'acceso_fuentes_financiamiento', label: 'Acceso a fuentes de financiamiento' },
      { value: 'inversiones', label: 'Inversiones' },
      { value: 'asesoria_financiera', label: 'Asesoría financiera' },
      { value: 'legal', label: 'Legal' },
      { value: 'digitalizacion_archivos', label: 'Digitalización de archivos' },
      { value: 'marketing_digital', label: 'Marketing digital' },
      { value: 'comercio_electronico', label: 'Comercio electrónico' },
      { value: 'otra', label: 'Otra' },
    ],
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'yes'
    },
  },
  {
    key: 'solutions_proposed',
    label: '¿Cuáles fueron las soluciones propuestas o herramientas implementadas durante la sesión?',
    type: 'text',
    required: true,
    minLength: 10,
    maxLength: 20000,
    colSpan: 2,
    showIf: {
      key: 'session_conducted',
      value: 'yes'
    },
  },
];

export const CLIENT_SUPPLIER_FORM: FormField[] = [
  {
    key: 'service_provided',
    label: '¿Se realizó el servicio?',
    type: 'radio',
    required: true,
    options: [
      {
        value: 'yes',
        label: 'Sí',
      },
      {
        value: 'no',
        label: 'No',
      },
    ],
    colSpan: 2,
  },
  {
    key: 'reason',
    label: '¿Cuál fue la razón?',
    type: 'textarea',
    required: true,
    minLength: 3,
    maxLength: 1000,
    colSpan: 2,
    showIf: {
      key: 'service_provided',
      value: 'no'
    },
  },
  {
    key: 'utility_rating',
    label: 'Del 1 al 5 ¿Como calificarías la utilidad del servicio recibido por el proveedor?',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Muy insatisfecho/a' },
      { value: 2, label: '2 - Ligeramente insatisfecho/a' },
      { value: 3, label: '3 - Neutral' },
      { value: 4, label: '4 - Satisfecho/a' },
      { value: 5, label: '5 - Muy satisfecho/a' },
    ],
    colSpan: 2,
    showIf: {
      key: 'service_provided',
      value: 'yes'
    },
  },
  {
    key: 'communication_rating',
    label: 'Del 1 al 5 ¿Qué tan satisfecho/a te sientes claridad y el trato recibido por parte del proveedor?',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Muy insatisfecho/a' },
      { value: 2, label: '2 - Ligeramente insatisfecho/a' },
      { value: 3, label: '3 - Neutral' },
      { value: 4, label: '4 - Satisfecho/a' },
      { value: 5, label: '5 - Muy satisfecho/a' },
    ],
    colSpan: 2,
    showIf: {
      key: 'service_provided',
      value: 'yes'
    },
  },
  {
    key: 'recommendation_rating',
    label: '¿Recomendarías este proveedor a otras personas interesadas?',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Totalmente en desacuerdo' },
      { value: 2, label: '2 - En desacuerdo con ciertos aspectos' },
      { value: 3, label: '3 - Indeciso/a' },
      { value: 4, label: '4 - De acuerdo con ciertos aspectos' },
      { value: 5, label: '5 - Totalmente de acuerdo' },
    ],
    colSpan: 2,
    showIf: {
      key: 'service_provided',
      value: 'yes'
    },
  },
  {
    key: 'valuable_aspects',
    label: 'Cuéntanos qué fue lo más valioso del servicio ¡Cada detalle nos importa!',
    type: 'textarea',
    required: true,
    minLength: 10,
    maxLength: 20000,
    colSpan: 2,
    showIf: {
      key: 'service_provided',
      value: 'yes'
    },
  },
  {
    key: 'improvement_aspects',
    label: 'Cuéntanos qué crees que este proveedor podría mejorar. ¡Cada consejo cuenta!',
    type: 'textarea',
    required: true,
    minLength: 10,
    maxLength: 20000,
    colSpan: 2,
    showIf: {
      key: 'service_provided',
      value: 'yes'
    },
  },
];

export const SUPPLIER_CLIENT_FORM: FormField[] = [
  {
    key: 'service_provided',
    label: '¿Se realizó el servicio?',
    type: 'radio',
    required: true,
    options: [
      {
        value: 'yes',
        label: 'Sí',
      },
      {
        value: 'no',
        label: 'No',
      },
    ],
    colSpan: 2,
  },
  {
    key: 'reason',
    label: '¿Cuál fue la razón?',
    type: 'textarea',
    required: true,
    minLength: 3,
    maxLength: 1000,
    colSpan: 2,
    showIf: {
      key: 'service_provided',
      value: 'no'
    },
  },
  {
    key: 'commitment_rating',
    label: 'Del 1 al 5 ¿Cómo calificarías la apertura y compromiso de este cliente con el proceso de trabajo?',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Malas' },
      { value: 2, label: '2 - Regular' },
      { value: 3, label: '3 - Neutral' },
      { value: 4, label: '4 - Buenas' },
      { value: 5, label: '5 - Excelentes' },
    ],
    colSpan: 2,
    showIf: {
      key: 'service_provided',
      value: 'yes'
    },
  },
  {
    key: 'availability_rating',
    label: 'Del 1 al 5 ¿Qué tan satisfecho/a te sientes con la disponibilidad y apertura del cliente al que le prestaste el servicio?',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Muy insatisfecho/a' },
      { value: 2, label: '2 - Ligeramente insatisfecho/a' },
      { value: 3, label: '3 - Neutral' },
      { value: 4, label: '4 - Satisfecho/a' },
      { value: 5, label: '5 - Muy satisfecho/a' },
    ],
    colSpan: 2,
    showIf: {
      key: 'service_provided',
      value: 'yes'
    },
  },
  {
    key: 'rework_rating',
    label: '¿Volverías a trabajar con este cliente?',
    type: 'radio',
    required: true,
    options: [
      {
        value: 'yes',
        label: 'Sí',
      },
      {
        value: 'no',
        label: 'No',
      },
    ],
    colSpan: 2,
    showIf: {
      key: 'service_provided',
      value: 'yes'
    },
  },
  {
    key: 'observations',
    label: 'Observaciones relevantes sobre el cliente',
    type: 'textarea',
    required: true,
    minLength: 10,
    maxLength: 20000,
    colSpan: 2,
    showIf: {
      key: 'service_provided',
      value: 'yes'
    },
  },
];

export const EVENT_SATISFACTION_FORM: FormField[] = [
  {
    key: 'activities_rating',
    label: 'Del 1 al 5 ¿Cómo calificarías las actividades desarrolladas durante el evento? ',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Malas' },
      { value: 2, label: '2 - Regular' },
      { value: 3, label: '3 - Neutral' },
      { value: 4, label: '4 - Buenas' },
      { value: 5, label: '5 - Excelentes' },
    ],
    colSpan: 2,
  },
  {
    key: 'team_rating',
    label: 'Del 1 al 5 ¿Cómo calificarías al equipo y la organización del evento?',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Malo' },
      { value: 2, label: '2 - Regular' },
      { value: 3, label: '3 - Neutral' },
      { value: 4, label: '4 - Bueno' },
      { value: 5, label: '5 - Excelente' },
    ],
    colSpan: 2,
  },
  {
    key: 'content_rating',
    label: 'Del 1 al 5 ¿Cuan valiosos crees que fueron el contenido y la información brindados en el evento?',
    type: 'radio',
    required: true,
    options: [
      { value: 1, label: '1 - Nada valioso' },
      { value: 2, label: '2 - Poco valioso' },
      { value: 3, label: '3 - Neutral' },
      { value: 4, label: '4 - Valioso' },
      { value: 5, label: '5 - Muy valioso' },
    ],
    colSpan: 2,
  },
  {
    key: 'recommendation_rating',
    label: '¿Volverías a inscribirte a eventos de este tipo?',
    type: 'radio',
    required: true,
    options: [
      {
        value: 'yes',
        label: 'Sí',
      },
      {
        value: 'no',
        label: 'No',
      },
    ],
    colSpan: 2,
  },
  {
    key: 'experience_feedback',
    label: 'Cuéntanos cuál fue tu experiencia en el evento ¡Cada detalle nos importa!',
    type: 'textarea',
    required: true,
    minLength: 10,
    maxLength: 20000,
    colSpan: 2,
  },
  {
    key: 'improvement_feedback',
    label: 'Cuéntanos cómo podriamos mejorar para un siguiente evento. ¡Cada consejo cuenta!',
    type: 'textarea',
    required: true,
    minLength: 10,
    maxLength: 20000,
    colSpan: 2,
  },
];